export var wait = function() {
    var millis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 300;
    return new Promise(function(resolve) {
        return window.setTimeout(resolve, millis);
    });
};
